<template>
  <div class="px-5 py-5 mt-5 md:px-0 md:w-full bg-stone-50">
    <div class="mx-auto md:max-w-6xl">
      <div class="flex flex-col md:flex-row md:items-center md:justify-between">
        <a
          href="/"
          @click="setActiveLink('home')"
          class="mb-5 w-36 text-primary hover:font-medium md:mb-0"
        >
          <img
            v-if="settings"
            :src="settings.photo"
            class="w-full md:h-full"
            alt="Hutloop logo"
          />
        </a>
        <div
          class="flex flex-col space-y-4 font-medium md:items-center md:pr-24 md:space-y-0 md:space-x-2 md:flex-row"
        >
          <div
            class="flex flex-col space-y-2 md:space-y-0 md:items-start md:flex-row md:w-full"
          >
            <a
              :href="
                $router.resolve({
                  name: 'FooterPages',
                  params: {
                    slug: 'about-us',
                  },
                }).href
              "
              @click="setActiveLink('about-us')"
              :class="{ 'active-link': activeLink === 'about-us' }"
              class="w-20 text-black nav-link hover:text-secondary"
            >
              About us
            </a>
            <a
              :href="
                $router.resolve({
                  name: 'FooterPages',
                  params: {
                    slug: 'terms-conditions',
                  },
                }).href
              "
              @click="setActiveLink('terms-conditions')"
              :class="{ 'active-link': activeLink === 'terms-conditions' }"
              class="w-40 text-black nav-link hover:text-secondary"
            >
              Terms & Conditions
            </a>
            <a
              :href="
                $router.resolve({
                  name: 'FooterPages',
                  params: {
                    slug: 'privacy-policy',
                  },
                }).href
              "
              @click="setActiveLink('privacy-policy')"
              :class="{ 'active-link': activeLink === 'privacy-policy' }"
              class="text-black w-28 nav-link hover:text-secondary"
            >
              Privacy Policy
            </a>
            <a
              :href="
                $router.resolve({
                  name: 'FooterPages',
                  params: {
                    slug: 'investments',
                  },
                }).href
              "
              @click="setActiveLink('investments')"
              :class="{ 'active-link': activeLink === 'investments' }"
              class="w-24 text-black nav-link hover:text-secondary"
            >
              Investment
            </a>
            <a
              href="/contact-us"
              @click="setActiveLink('contact-us')"
              :class="{ 'active-link': activeLink === 'contact-us' }"
              class="w-24 text-black nav-link hover:text-secondary"
            >
              Contact Us
            </a>
            <a
              :href="
                $router.resolve({
                  name: 'FooterPages',
                  params: {
                    slug: 'careers',
                  },
                }).href
              "
              @click="setActiveLink('careers')"
              :class="{ 'active-link': activeLink === 'careers' }"
              class="w-20 text-black nav-link hover:text-secondary"
            >
              Careers
            </a>
            <a
              :href="
                $router.resolve({
                  name: 'FooterPages',
                  params: {
                    slug: 'advertise',
                  },
                }).href
              "
              @click="setActiveLink('advertise')"
              :class="{ 'active-link': activeLink === 'advertise' }"
              class="w-24 text-black nav-link hover:text-secondary"
            >
              Advertise
            </a>
          </div>
        </div>
        <div class="flex flex-col items-end mt-5 md:mt-0">
          <div class="flex flex-row space-x-2">
            <a href="https://facebook.com/hutloop" target="__blank__">
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 180.28 180.28"
                style="enable-background: new 0 0 180.28 180.28"
                xml:space="preserve"
                class="w-4 h-4"
              >
                <path
                  class="st0"
                  d="M159.63,180.28H20.65C9.25,180.28,0,171.03,0,159.63V20.65C0,9.25,9.25,0,20.65,0h138.98
	c11.41,0,20.65,9.25,20.65,20.65v138.98C180.28,171.03,171.03,180.28,159.63,180.28z"
                />
                <g id="XMLID_6_">
                  <path
                    id="XMLID_147_"
                    class="st1"
                    d="M76.87,153.6h24.59V96.88h18.16l3.63-22.91h-21.8V56.64c0-6.43,6.15-10.06,12.02-10.06h10.62
		v-19l-19-0.84c-18.16-1.12-28.22,13.13-28.22,30.18v17.05H56.19v22.91h20.68V153.6z"
                  />
                </g>
              </svg>
            </a>
            <a href="https://instagram.com/hutloop" target="__blank__">
              <div>
                <svg
                  version="1.1"
                  id="Layer_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 180.28 180.28"
                  style="enable-background: new 0 0 180.28 180.28"
                  xml:space="preserve"
                  class="w-4 h-4"
                >
                  <path
                    class="st0"
                    d="M159.63,180.28H20.65C9.25,180.28,0,171.03,0,159.63V20.65C0,9.25,9.25,0,20.65,0h138.98
	c11.41,0,20.65,9.25,20.65,20.65v138.98C180.28,171.03,171.03,180.28,159.63,180.28z"
                  />
                  <g id="XMLID_8_">
                    <path
                      id="XMLID_3_"
                      class="st1"
                      d="M63.63,31.81h53.02c17.03,0,31.05,14.01,31.05,31.05v52.75c0,17.03-14.01,31.05-31.05,31.05
		H63.63c-17.03,0-31.05-14.01-31.05-31.05V62.86C32.58,45.82,46.59,31.81,63.63,31.81L63.63,31.81z M121.05,51.87L121.05,51.87
		c3.57,0,6.59,3.02,6.59,6.59l0,0c0,3.57-3.02,6.59-6.59,6.59l0,0c-3.85,0-6.59-3.02-6.59-6.59l0,0
		C114.45,54.89,117.2,51.87,121.05,51.87L121.05,51.87z M90,57.91h0.27c17.03,0,31.32,14.29,31.32,31.32l0,0
		c0,17.31-14.29,31.32-31.32,31.32H90c-17.03,0-31.05-14.01-31.05-31.32l0,0C58.96,72.2,72.97,57.91,90,57.91L90,57.91z M90,68.63
		h0.27c11.26,0,20.61,9.34,20.61,20.61l0,0c0,11.54-9.34,20.88-20.61,20.88H90c-11.26,0-20.61-9.34-20.61-20.88l0,0
		C69.4,77.97,78.74,68.63,90,68.63L90,68.63z M63.9,41.7h52.47c11.81,0,21.43,9.62,21.43,21.43v52.2c0,11.81-9.62,21.43-21.43,21.43
		H63.9c-11.81,0-21.43-9.62-21.43-21.43v-52.2C42.47,51.32,52.09,41.7,63.9,41.7L63.9,41.7z"
                    />
                  </g>
                </svg>
              </div>
            </a>
            <a
              href="https://www.linkedin.com/company/hutloop"
              target="__blank__"
            >
              <!-- Generator: Adobe Illustrator 28.3.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
              <svg
                version="1.1"
                id="Layer_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                viewBox="0 0 180.28 180.28"
                style="enable-background: new 0 0 180.28 180.28"
                xml:space="preserve"
                class="w-4 h-4"
              >
                <path
                  class="st0"
                  d="M159.63,180.28H20.65C9.25,180.28,0,171.03,0,159.63V20.65C0,9.25,9.25,0,20.65,0h138.98
	c11.41,0,20.65,9.25,20.65,20.65v138.98C180.28,171.03,171.03,180.28,159.63,180.28z"
                />
                <g id="XMLID_12_">
                  <path
                    id="XMLID_13_"
                    class="st1"
                    d="M41.02,73.35h20.3v68.17h-20.3V73.35z M51.04,38.76c6.77,0,12.28,5.51,12.28,12.28
		c0,6.77-5.51,12.28-12.28,12.28c-6.77,0-12.03-5.51-12.03-12.28C39.01,44.28,44.28,38.76,51.04,38.76L51.04,38.76z M73.35,73.35
		H93.4v9.52c4.26-6.27,11.28-10.28,19.3-10.28h5.51c12.78,0,23.06,10.53,23.06,23.06v10.28v12.28v23.31h-20.05v-0.25v-6.01l0,0
		v-30.57l0,0c-0.25-7.77-5.51-13.78-13.28-13.78l0,0c-7.77,0-14.28,6.01-14.54,13.78l0,0v26.56v10.28H73.35V73.35z"
                  />
                </g>
              </svg>
            </a>
          </div>
          <div class="mt-2">
            <p class="text-sm font-normal text-center md:text-right">
              <span class="text-xs">©️</span> 2024 Hutloop
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "FooterView",
};
</script>
<script setup>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
const store = useStore();
const settings = ref("");
const activeLink = ref(sessionStorage.getItem("activeLink") || "");
const loadSettings = async () => {
  await store.dispatch("fetchSettings");
  settings.value = store.state.settings.data;
  // console.log(settings.value);
};
const setActiveLink = (link) => {
  activeLink.value = link;
  sessionStorage.setItem("activeLink", link);
};

onMounted(() => {
  loadSettings();
  const storedLink = sessionStorage.getItem("activeLink");
  if (storedLink) {
    activeLink.value = storedLink;
  }
});
</script>
<style scoped>
/* CSS */
.nav-link {
  transition: font-weight 0.2s ease;
  color: #4f4f4f;
  font-size: 14.5px;
  font-weight: 400;
}

.active-link {
  font-weight: bolder !important;
  color: #c01823 !important;
}

.st0 {
  fill-rule: evenodd;
  clip-rule: evenodd;
}
.st0:hover {
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #c01823;
}

.st1 {
  fill-rule: evenodd;
  clip-rule: evenodd;
  fill: #ffffff;
}
</style>
